module.exports = __webpack_public_path__ + "static/media/warning.c2dabb42.png";